import * as React from "react";
const SvgFiRrPlan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plan_svg__a)">
      <path
        fill="#062147"
        d="M17.163 13c.434 1.441 1.757 2.5 3.337 2.5 1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5c-1.58 0-2.903 1.059-3.337 2.5H16V6a1.5 1.5 0 0 1 1.175-1.462C17.62 5.959 18.934 7 20.5 7 22.43 7 24 5.43 24 3.5S22.43 0 20.5 0c-1.593 0-2.926 1.076-3.348 2.535C15.387 2.713 14 4.189 14 6v5h-1a1 1 0 1 0 0 2h1v5c0 1.811 1.388 3.287 3.152 3.465C17.574 22.924 18.907 24 20.5 24c1.93 0 3.5-1.57 3.5-3.5S22.43 17 20.5 17c-1.566 0-2.88 1.041-3.325 2.462A1.5 1.5 0 0 1 16 18v-5zm3.337-2.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5S19 12.827 19 12s.673-1.5 1.5-1.5m0-8.5c.827 0 1.5.673 1.5 1.5S21.327 5 20.5 5 19 4.327 19 3.5 19.673 2 20.5 2m0 17c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5M11.632 8.756a.997.997 0 0 0-1.365-.367l-.977.563a4.5 4.5 0 0 0-2.289-1.331V6.5a1 1 0 1 0-2 0v1.121a4.48 4.48 0 0 0-2.289 1.331l-.977-.563a1 1 0 1 0-.998 1.732l.983.566A4.4 4.4 0 0 0 1.502 12c0 .46.089.895.218 1.313l-.983.566a1 1 0 1 0 .998 1.732l.977-.563a4.5 4.5 0 0 0 2.289 1.331V17.5a1 1 0 1 0 2 0v-1.121a4.48 4.48 0 0 0 2.289-1.331l.977.563a.998.998 0 0 0 1.365-.367 1 1 0 0 0-.367-1.365l-.983-.566c.129-.418.218-.853.218-1.313s-.089-.895-.218-1.313l.983-.566a1 1 0 0 0 .367-1.365M6 14.5A2.5 2.5 0 0 1 3.5 12c0-1.379 1.121-2.5 2.5-2.5s2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plan_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlan;
